module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_7",
      "title": "7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1"
  }, [_vm._v("I want to thank Lance Polingyouma, Lynn Bullock, and my other coworkers at the Heard Museum for their supreme patience while I hammered this book out on my lunch breaks (and sometimes went over because I lost track of time). Thanks to Elinor Mavor for editing the novella and making it salable, to Neil Clarke for publishing the original novella (even though it was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("really")]), _vm._v(" long), and to Martha Millard and Jen Gunnels for helping me whip the novel-length manuscript into shape. And thanks to my mom, Margaret Devenport. If I don’t mention her, she’s going to say, “Hey! What about your mom?!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0